<div class="app">
	<router-outlet></router-outlet>
	<app-language-selector></app-language-selector>
</div>